module.exports = __webpack_public_path__ + "static/media/usn-2n.8d1b1fdd.jpg";